import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static targets = ["chart"];
  static values = { data: Array };

  connect() {
    this.#renderChart();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }

  // Private

  #renderChart() {
    const data = this.dataValue;
    const categories = data.map((d) => d.label);
    const counts = data.map((d) => d.count);

    const options = {
      chart: {
        type: "area",
        height: 256,
        background: "transparent",
        toolbar: { show: false },
        animations: { speed: 400, animateGradually: { enabled: false } },
        zoom: { enabled: false },
      },
      series: [{ name: "Scans", data: counts }],
      xaxis: {
        categories,
        labels: {
          style: {
            colors: "rgba(245, 221, 215, 0.3)",
            fontSize: "10px",
            fontWeight: 700,
            fontFamily: "Inter, sans-serif",
          },
          showDuplicates: false,
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
        crosshairs: {
          show: true,
          stroke: { color: "#ffb5a0", width: 1, dashArray: 4 },
        },
        tooltip: { enabled: false },
      },
      yaxis: { show: false },
      grid: {
        show: true,
        borderColor: "rgba(245, 221, 215, 0.06)",
        strokeDashArray: 4,
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: true } },
      },
      stroke: {
        curve: "smooth",
        width: 2.5,
        colors: ["#ffb5a0"],
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0.02,
          stops: [0, 100],
          colorStops: [
            { offset: 0, color: "#ffb5a0", opacity: 0.4 },
            { offset: 100, color: "#ffb5a0", opacity: 0.02 },
          ],
        },
      },
      colors: ["#ffb5a0"],
      markers: {
        size: 0,
        hover: { size: 5, sizeOffset: 3 },
        colors: ["#ffb5a0"],
        strokeColors: "#352723",
        strokeWidth: 2,
      },
      dataLabels: { enabled: false },
      tooltip: {
        custom({ series, seriesIndex, dataPointIndex }) {
          const val = series[seriesIndex][dataPointIndex];
          const label = categories[dataPointIndex];
          return `<div style="
            background: #352723;
            border: 1px solid rgba(255,181,160,0.15);
            border-radius: 8px;
            padding: 8px 14px;
            font-family: Inter, sans-serif;
            box-shadow: 0 8px 24px rgba(0,0,0,0.4);
          ">
            <div style="color: rgba(245,221,215,0.5); font-size: 11px; font-weight: 600; margin-bottom: 2px;">${label}</div>
            <div style="color: #ffb5a0; font-size: 20px; font-weight: 900;">${val} <span style="color: rgba(245,221,215,0.4); font-size: 13px; font-weight: 500;">scans</span></div>
          </div>`;
        },
      },
      theme: { mode: "dark" },
    };

    this.chart = new ApexCharts(this.chartTarget, options);
    this.chart.render();
  }
}
